import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0063A1", // أزرق ملكي قوي
      light: "#3E95BE", // أزرق سماوي متوسط (درجة أفتح)
      dark: "#004D7B", // أزرق غامق لمزيد من العمق
    },
    secondary: {
      main: "#0063A1", // أزرق ملكي قوي
      light: "#3E95BE", // أزرق سماوي متوسط (درجة أفتح)
      dark: "#004D7B",
    },
    background: {
      default: "#ffffff", // خلفية بيضاء للنقاء والهدوء
      paper: "#f5f5f5", // رمادي فاتح لعناصر الورق والتباين
    },
    text: {
      primary: "#1c1c1c", // لون أسود داكن للنصوص الرئيسية
      secondary: "#0063A1", // لون أزرق ملكي للنصوص الثانوية
      contrast: "#3E95BE", // لون أزرق سماوي للعناوين البارزة
    },
  },
  typography: {
    fontFamily: "Emirates",
  },
});

export default theme;
